export default __webpack_public_path__ + "static/media/certificado-3.0b20fc9e.webp";